import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Cookies from 'js-cookie';
import { FavouritesAction } from '../../../molecules/favourites-action/js/favourites-action';

const classes = {
	stateBtnActive: "state-m-favourite-button--active",
	stateBtnLocked: "state-m-favourite-button--locked",
	statePopupVisible: "state-favourite-popup--visible",
	statePopupClose: "state-favourite-popup--close",
	stateValMsgVisible: "state-field-validation-error--visible",
	stateLoadingVisible: "state-loading-wrapper--shown",
	stateCountMax: "state-textarea-count-max",

	noScrollingBar: "no-scrolling--without-scrollbar",

	favouriteBtn: "m-favourite-button",
	dynamicPopupContainer: "m-favourite-dynamic-popup-container",
	staticPopupContainer: "m-favourite-static-popup-container",
	successPromptPopup: "js-m-modal-actions-success-prompt",
	failurePromptPopup: "js-m-modal-actions-failure-prompt",

	loadingIndicator: "m-favourite-button__loading-wrapper",

	popupContainer: "m-modal-actions",
};

const productCompareClasses = {
	productCompare: "o-product-compare",
	productName: "js-o-product-compare__productname"
}

const productFinderClasses = {
	selectedCountry: "m-selected-filter-tags__country",
	tagfilter: "a-tag-filter "
}

const popupClasses = {
	popupBox: "js-m-modal-actions",
	textareaContainer: "js-m-modal-actions-textarea-container",
	textareaBox: "js-m-modal-actions__textarea",
	textareaValLength: "js-m-modal-actions__textarea-count-length",
	textareaValLengthMax: "js-m-modal-actions__textarea-count-max",

	confirmationBtn: "js-m-modal-actions-confirmation",

	textcheckboxContainer: "js-m-modal-actions-textcheckbox-container",
	textboxContainer: "js-m-modal-actions-textbox-container",
	textboxGroup: "m-modal-actions__new-list-input",
	textbox: "js-m-modal-actions__newlist",

	checklistContainer: "js-m-modal-actions-checklist-container",
	allChecklistContainer: "js-m-modal-actions-all-checklist-container",

	inputValidationError: "input-validation-error",
	fieldValidationError: "js-checklist-validation-error",
}

@createModule('FavouriteButton')
/**
 * FavouriteButton Component
 */
export class FavouriteButton extends TerrificSpec {
	$ctx: JQuery;
	$localFavouritesButton: any;
	$globalFavouritesButton: any;
	$dynamicPopupContainer: any;
	$staticPopupContainer: any;
	$successPopup: any;
	$failurePopup: any;

	$loadingIndicator: any;

	pageId: string;
	templateId: string;
	enableFavourite: boolean;

	statusApiEndpoint: string;
	actionViewEndpoint: string;

	// the cookies-key of "don't show this confirmation again" message box
	confirmationKey: string;

	favorAction: any;

	start(resolve: () => void) {
		this.confirmationKey = "favor_confirmation";

		this.$ctx = $(this._ctx);

		this.$localFavouritesButton = this.$ctx.find(`button.${classes.favouriteBtn}`);

		// for there may have multiple favourite button in a page, we use the global selector
		this.$globalFavouritesButton = $("html").find(`button.${classes.favouriteBtn}`);

		this.$dynamicPopupContainer = this.$ctx.find(`.${classes.dynamicPopupContainer}`);
		this.$staticPopupContainer = this.$ctx.find(`.${classes.staticPopupContainer}`);

		this.$successPopup = this.$ctx.find(`.${classes.successPromptPopup}`);
		this.$failurePopup = this.$ctx.find(`.${classes.failurePromptPopup}`);

		this.$loadingIndicator = this.$ctx.find(`.${classes.loadingIndicator}`);

		this.pageId = this.$ctx.data("page-id");
		this.enableFavourite = this.$ctx.data("enable-favourites");

		this.statusApiEndpoint = this.$ctx.data("status-api-endpoint");
		this.actionViewEndpoint = this.$ctx.data("action-view-endpoint");

		this.favorAction = new FavouritesAction();

		if (this.enableFavourite) {
			this.updateStatus();
		}
		
		this.$localFavouritesButton.on('click', (ev: any) => {
			const $favorBtn = $(ev.currentTarget);
			let actionType = "";
			if ($favorBtn.hasClass(classes.stateBtnActive)) {
				actionType = "RemoveEntry";
			} else {
				actionType = "AddEntry";
			}
			this.getActionPartialView(actionType, this.pageId);
		});

		this.$failurePopup.find(`.${classes.statePopupClose}`).on("click", (event: any) => {
			const $closeBtn = $(event.currentTarget);
			this.closeStaticPopup($closeBtn);
		});

		this.$successPopup.find(`.${classes.statePopupClose}`).on("click", (ev: any) => {
			ev.stopPropagation();
			this.closeSuccessPopup();
		});

		resolve();
	}


	updateStatus() {
		const query = window.location.search.substr(1);
		$.ajax({
			type: 'GET',
			url: this.statusApiEndpoint,
			dataType: 'json',
			data:
			{
				pageid: this.pageId,
				query: query
			},
			success: (response: any) => {
				this.updateFavouriteButton(response.isActive);
			},
			complete: () => {

			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`update status error, ${xhr.status}, ${xhr.statusText}, ${error}`);
			}
		});
	}

	getActionPartialView(actionType: string, id: string) {
		this.lockScreen();
		$.ajax({
			type: 'post',
			url: this.actionViewEndpoint,
			dataType: 'html',
			data:
			{
				actionType: actionType,
				pageId: id,
				CurrentUrl: window.location.href
			},
			success: (response: any) => {
				this.$dynamicPopupContainer.append(response);
				const $popup = this.$dynamicPopupContainer.children();

				let data = this.$dynamicPopupContainer.find("script[type='application/json']");
				if (data.length > 0) {
					let json = data[0].innerHTML;
					if (json.length > 0) {

						let jsonData = JSON.parse(json);

						// if the page is only available on one list, won't show the popup
						if (jsonData.disablePopup) {

							this.favorAction.removePopup($popup);
							this.updateFavouriteButton(false);

							return;
						}
					}

				}

				this.favorAction.displayPopup($popup);
				this.favorAction.rebindCommonViewEvents($popup);
				this.bindSubmitEvent($popup);
				this.prefillTextareaBox();
			},
			complete: () => {
				this.unlockScreen();
			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`get action-view error, ${xhr.status}, ${xhr.statusText}, ${error}`);
			}
		});
	}

	bindSubmitEvent($popup: JQuery) {

		// bind submit button
		$popup.find(`.${popupClasses.confirmationBtn}`).on('click', (ev: any) => {
			if (this.favorAction.canSubmit($popup)) {

				const $btn = $(ev.currentTarget);

				const url = $popup.data("api-endpoint");
				const id = $popup.data("item-id");

				const textareaValue = $popup.find("textarea").val();

				const ids = this.favorAction.getCheckedListIds($popup);

				const textboxValue = this.favorAction.getTextCheckBoxValue($popup);

				this.favorAction.lockSubmitBtn($btn);

				$.ajax({
					type: 'post',
					url: url,
					dataType: 'json',
					data:
					{
						pageId: id,
						ids: ids,
						textareaInput: textareaValue,
						textInput: textboxValue,
						currentUrl: window.location.href
					},
					success: (response: any) => {
						if (response.success) {
							this.updateFavouriteButton(response.isActive);
							if (response.enablePrompt) {
								this.showSuccessPopup();
							}
						}
						else {
							this.showStaticPopup(this.$failurePopup);
							console.log(response.message);
						}
					},
					complete: () => {
						this.favorAction.removePopup($popup);
						this.favorAction.unlockSubmitBtn($btn);
					},
					error: (xhr: any, status: string, error: string) => {
						console.log(`submit action-view error, endpoint: ${url}, ${xhr.status}, ${xhr.statusText}, ${error}`);
					}
				});
			}
		});
	}

	lockScreen() {
		this.$loadingIndicator.addClass(classes.stateLoadingVisible);
	}

	unlockScreen() {
		this.$loadingIndicator.removeClass(classes.stateLoadingVisible);

	}

	updateFavouriteButton(isActive: boolean) {
		if (isActive) {
			this.$globalFavouritesButton.addClass(classes.stateBtnActive);
		} else {
			this.$globalFavouritesButton.removeClass(classes.stateBtnActive);
		}
	}

	showSuccessPopup() {
		let confirmationCookie = Cookies.get(this.confirmationKey);
		if (!confirmationCookie) {
			this.showStaticPopup(this.$successPopup);
		}
	}

	closeSuccessPopup() {
		const ckBox = this.$successPopup.find("input[type=checkbox]").prop("checked");

		if (ckBox) {
			Cookies.set(this.confirmationKey, '1', { expires: 365 });
			const curScrollTop = $(window).scrollTop();

			$(window).scrollTop(curScrollTop - 20);
			$('.m-navigation-meta__tooltip-favourite').fadeIn();

		}

		this.$successPopup.removeClass(classes.statePopupVisible);
	}

	showStaticPopup($container: any) {
		$container.addClass(classes.statePopupVisible);
	}

	closeStaticPopup($closeBtn: any) {
		$closeBtn.parents(`.${classes.popupContainer}`).removeClass(classes.statePopupVisible);
	}

	prefillTextareaBox() {

		const $descInputBox = this.$dynamicPopupContainer.find(`.${popupClasses.textareaBox}`);

		if ($descInputBox.length > 0) {

			let descVal = "";

			const $productCompareNameEles = $("html").find(`.${productCompareClasses.productCompare}`).find(`.${productCompareClasses.productName}`);

			const $productFinderSelectedCountry = $("html").find(`.${productFinderClasses.selectedCountry}`).find("span");
			const $productFinderNameEles = $("html").find("cov-tag-filter").find(`button.${productFinderClasses.tagfilter}`);

			if ($productCompareNameEles.length > 0) {
				descVal = this.getElementsText($productCompareNameEles);

			} else if ($productFinderSelectedCountry.length > 0 || $productFinderNameEles.length > 0) {

				descVal = $productFinderSelectedCountry.text();
				const filterTxt = this.getElementsText($productFinderNameEles);

				if (filterTxt.length > 0) {
					descVal = `${descVal} - ${filterTxt}`
				}
			}
			else {
				descVal = this.getPageTitle();
			}

			$descInputBox.val(descVal);

			$descInputBox.focus();

			this.favorAction.countTextarea($descInputBox);
		}

	}

	getPageTitle(): string {
		const docTitle = document.title;

		let result = "";

		if (docTitle.indexOf("|") != -1) {
			const title = docTitle.split("|");
			result = title[0].trim();
		} else {
			result = docTitle;
		}

		return result;
	}

	getElementsText($nameEles: any): string {
		let result = "";

		const nameArr = new Array<string>();
		$nameEles.each((i: any, e: any) => {
			const value = $(e).text().trim();
			if (typeof (value) != "undefined") {
				nameArr.push(value);
			}
		});
		result = nameArr.join(" - ");

		return result;
	}

	getActionPartialViewForEventList(actionType: string,ev: any) {
		const $favorBtn = $(ev.currentTarget);
		var favorAction = new FavouritesAction();
		var favoriteCtx=$favorBtn.closest("div[data-t-name='FavouriteButton']");
		var pageid=favoriteCtx.attr("data-page-id");
		var actionViewEndpoint=favoriteCtx.attr("data-action-view-endpoint");
		$favorBtn.siblings(`.${classes.loadingIndicator}`).addClass(classes.stateLoadingVisible);
		$.ajax({
			type: 'post',
			url:actionViewEndpoint,
			dataType: 'html',
			data:
			{
				actionType: actionType,
				pageId: pageid,
				CurrentUrl: window.location.href
			},
			success: (response: any) => {
				$favorBtn.siblings((`.${classes.dynamicPopupContainer}`)).append(response);
				const $popup = $favorBtn.siblings((`.${classes.dynamicPopupContainer}`)).children();
				const $staicPopup=$favorBtn.siblings((`.${classes.staticPopupContainer}`));
				let data =$favorBtn.siblings((`.${classes.dynamicPopupContainer}`)).find("script[type='application/json']");
				if (data.length > 0) {
					let json = data[0].innerHTML;
					if (json.length > 0) {

						let jsonData = JSON.parse(json);

						// if the page is only available on one list, won't show the popup
						if (jsonData.disablePopup) {

							favorAction.removePopup($popup);
							$favorBtn.removeClass(classes.stateBtnActive);
							return;
						}
					}

				}

				favorAction.displayPopup($popup);
				favorAction.rebindCommonViewEvents($popup);
				this.bindSubmitEventForEventList($popup,$staicPopup,$favorBtn);
				this.prefillTextareaBoxForEventList($popup);
			},
			complete: () => {
				$favorBtn.siblings(`.${classes.loadingIndicator}`).removeClass(classes.stateLoadingVisible);
			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`get action-view error, ${xhr.status}, ${xhr.statusText}, ${error}`);
			}
		});
	}

	bindSubmitEventForEventList($popup: JQuery,$staicPopup: JQuery,$button: any) {

		// bind submit button
		var favorAction = new FavouritesAction();
		$popup.find(`.${popupClasses.confirmationBtn}`).on('click', (ev: any) => {
			if (favorAction.canSubmit($popup)) {

				const $btn = $(ev.currentTarget);

				const url = $popup.data("api-endpoint");
				const id = $popup.data("item-id");

				const textareaValue = $popup.find("textarea").val();

				const ids = favorAction.getCheckedListIds($popup);

				const textboxValue = favorAction.getTextCheckBoxValue($popup);

				favorAction.lockSubmitBtn($btn);

				$.ajax({
					type: 'post',
					url: url,
					dataType: 'json',
					data:
					{
						pageId: id,
						ids: ids,
						textareaInput: textareaValue,
						textInput: textboxValue,
						currentUrl: window.location.href
					},
					success: (response: any) => {
						if (response.success) {
							if (response.isActive) {
								$button.addClass(classes.stateBtnActive);
							} else {
								$button.removeClass(classes.stateBtnActive);
							}
							if (response.enablePrompt) {
								let confirmationCookie = Cookies.get("favor_confirmation");
							if (!confirmationCookie) {
								var $successPopup=$staicPopup.find(`.${classes.successPromptPopup}`);
								$successPopup.addClass(classes.statePopupVisible);
							
								$successPopup.find(`.${classes.statePopupClose}`).on("click", (ev: any) => {
									ev.stopPropagation();
									const ckBox = $successPopup.find("input[type=checkbox]").prop("checked");

									if (ckBox) {
										Cookies.set(this.confirmationKey, '1', { expires: 365 });
										const curScrollTop = $(window).scrollTop();

										$(window).scrollTop(curScrollTop - 20);
										$('.m-navigation-meta__tooltip-favourite').fadeIn();

									}

									$successPopup.removeClass(classes.statePopupVisible);
								});
								}
							}
						}
						else {
							var $failurePopup=$staicPopup.find(`.${classes.failurePromptPopup}`);
							$failurePopup.addClass(classes.statePopupVisible);
							$failurePopup.find(`.${classes.statePopupClose}`).on("click", (event: any) => {
								$failurePopup.removeClass(classes.statePopupVisible);
							});
							console.log(response.message);
						}
					},
					complete: () => {
						favorAction.removePopup($popup);
						favorAction.unlockSubmitBtn($btn);
					},
					error: (xhr: any, status: string, error: string) => {
						console.log(`submit action-view error, endpoint: ${url}, ${xhr.status}, ${xhr.statusText}, ${error}`);
					}
				});
			}
		});
	}

	updateStatusForEventList(ev: any) {
		const query = window.location.search.substr(1);
		const $favorBtn = $(ev);
		var favoriteCtx=$favorBtn.closest("div[data-t-name='FavouriteButton']");
		var pageid=favoriteCtx.attr("data-page-id");
		var statusEndpoint=favoriteCtx.attr("data-status-api-endpoint");
		$.ajax({
			type: 'GET',
			url: statusEndpoint,
			dataType: 'json',
			data:
			{
				pageid: pageid,
				query: query
			},
			success: (response: any) => {
				if (response.isActive) {
					$favorBtn.addClass(classes.stateBtnActive);
				} else {
					$favorBtn.removeClass(classes.stateBtnActive);
				}
			},
			complete: () => {

			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`update status error, ${xhr.status}, ${xhr.statusText}, ${error}`);
			}
		});
	}

	prefillTextareaBoxForEventList($popup: JQuery) {

		const $descInputBox = $popup.find(`.${popupClasses.textareaBox}`);

		if ($descInputBox.length > 0) {
			$descInputBox.focus();
			var favorAction=new FavouritesAction();
			favorAction.countTextarea($descInputBox);
		}

	}
	stop() { }
}
